import api from './api';

export interface AuditLogEntry {
  id: number;
  user_id: string | null;
  email: string | null;
  event: 'login_success' | 'login_failed' | 'logout' | string;
  ip_address: string | null;
  user_agent: string | null;
  created_at: string;
  user?: { user_id: string; full_name: string } | null;
}

interface AuditLogResponse {
  status: boolean;
  message: string;
  data: AuditLogEntry[];
  pagination: {
    current_page: number;
    per_page: number;
    total: number;
    last_page: number;
  };
}

const auditLogService = {
  getAuditLogs: async (page = 1, event?: string): Promise<AuditLogResponse> => {
    const response = await api.get('/audit-logs', { params: { page, event } });
    return response.data;
  },
};

export default auditLogService;
